export default {
  title: 'O que acha de {{name}}?',
  description: 'O seu feedback é anónimo e ajuda-nos a melhorar.',
  upload_google_review: {
    title: 'Avalie-nos e ganhe recompensas',
  },
};
